import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Plus, X, Upload } from "lucide-react";
import toast from "react-hot-toast";
import Dropdown from "../../../Component/Dropdown/Drowdown";
import apiRequests from "../../../Component/axios/config/config";

export default function ProductCreate() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    attributes: {
      color: "",
      size: "",
    },
    images: [],
    // isActive: true
  });

  const [loadingImage, setLoadingImage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [imageUrl, setImageUrl] = useState([]);
  const [showModalCategory, setShowModalCategory] = useState(false);
  const [CategoryListData, setCategoryListData] = useState([]);
  const [Category, setCategory] = useState({
    id: "",
    name: "",
  });

  useEffect(() => {
    apiRequests
      .get("api/category/get-all-admin")
      .then((res) => {
        setCategoryListData(res.data.data);
      })
      .catch()
      .finally(() => {});
  }, []);

  useEffect(() => {
    setFormData({ ...formData, category: Category.id });
  }, [Category]);

  // const handleImageUpload = async (files) => {
  //
  // };

  // const addAttribute = () => {
  //     if (newAttribute.key && newAttribute.value) {
  //         setFormData(prev => ({
  //             ...prev,
  //             attributes: [...prev.attributes, newAttribute]
  //         }));
  //         setNewAttribute({ key: "", value: "" });
  //     }
  // };

  // const removeAttribute = (index) => {
  //     setFormData(prev => ({
  //         ...prev,
  //         attributes: prev.attributes.filter((_, i) => i !== index)
  //     }));
  // };

  const removeImage = (image) => {};

  function readImage() {
    document.querySelector("#profile")?.click();
  }

  function UploadImage(e) {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    setLoadingImage(true);
    apiRequests
      .post(`/api/file/v1/upload-admin`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        toast.success("Upload Image successfully");
        setImageUrl([...imageUrl, URL.createObjectURL(e.target.files[0])]);
        setFormData((prevFormData) => ({
          ...prevFormData,
          images: [...prevFormData.images, response.data.message._id],
        }));
      })
      .catch((err) => {})
      .finally(() => {
        setLoadingImage(false);
      });
  }

  function createProduct() {
    setIsLoading(true);
    apiRequests
      .post("/api/product/create-admin", formData)
      .then((response) => {
        toast.success(response.data.en_message);
        setFormData({
          name: "",
          description: "",
          price: "",
          category: "",
          attributes: {
            color: "",
            size: "",
          },
          images: [],
          // isActive: true
        });
        setImageUrl([]);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold">Create New Product</h1>
          <button
            onClick={() => navigate(-1)}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-2 font-medium">Product Name *</label>
              <input
                type="text"
                required
                placeholder="enter name"
                className="w-full p-2 border rounded-lg"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>

            <div>
              <label className="block mb-2 font-medium">Price *</label>
              <input
                type="number"
                required
                placeholder="enter price"
                className="w-full p-2 border rounded-lg"
                value={formData.price}
                onChange={(e) =>
                  setFormData({ ...formData, price: parseInt(e.target.value) })
                }
              />
            </div>

            <div>
              <label className="block mb-2 font-medium">Category *</label>
              <div
                className="inline-block relative w-full"
                onClick={() => setShowModalCategory(!showModalCategory)}
              >
                <input
                  className="w-full p-2 border rounded-lg"
                  value={Category.name}
                  readOnly
                  placeholder="enter category"
                />

                {showModalCategory && (
                  <Dropdown
                    data={CategoryListData}
                    setOpen={setShowModalCategory}
                    setValue={setCategory}
                  />
                )}
              </div>
            </div>

            {/*<div className="flex items-center gap-4">*/}
            {/*    <label className="font-medium">Status:</label>*/}
            {/*    <button*/}
            {/*        type="button"*/}
            {/*        onClick={() => setFormData({...formData, isActive: !formData.isActive})}*/}
            {/*        className="flex items-center gap-2"*/}
            {/*    >*/}
            {/*        {formData.isActive ? (*/}
            {/*            <ToggleRight className="text-green-500" size={24}/>*/}
            {/*        ) : (*/}
            {/*            <ToggleLeft className="text-gray-400" size={24}/>*/}
            {/*        )}*/}
            {/*    </button>*/}
            {/*</div>*/}
          </div>

          <div className="mt-4">
            <label className="block mb-2 font-medium">Description *</label>
            <textarea
              required
              rows={4}
              placeholder="enter description"
              className="w-full p-2 border rounded-lg"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </div>

          <div className="mt-6">
            <label className="block mb-2 font-medium">Product Images *</label>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {imageUrl.map((img, index) => {
                return (
                  <div key={index} className="relative group">
                    <img
                      src={img}
                      alt="Preview"
                      className="h-32 w-full object-cover rounded-lg border"
                    />
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    onClick={() => removeImage(img)}*/}
                    {/*    className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100"*/}
                    {/*>*/}
                    {/*    <Trash2 className="w-4 h-4 text-red-600" />*/}
                    {/*</button>*/}
                  </div>
                );
              })}
              <label className="h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                {!loadingImage && (
                  <input
                    type="file"
                    accept="image/*"
                    onClick={() => readImage()}
                    onChange={UploadImage}
                    className="hidden"
                  />
                )}

                <div className="text-center text-gray-500">
                  {loadingImage ? (
                    <div className="mx-auto mb-2">
                      <svg
                        aria-hidden="true"
                        className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  ) : (
                    <Upload className="mx-auto mb-2" />
                  )}

                  <span>{loadingImage ? "Uploading..." : "Upload Images"}</span>
                </div>
              </label>
            </div>
          </div>

          <div className="mt-6">
            <label className="block mb-2 font-medium">Attributes</label>
            <div className="space-y-2">
              {/*{formData.attributes.map((attr, index) => (*/}
              {/*    <div key={index} className="flex gap-2">*/}
              {/*        <input*/}
              {/*            type="text"*/}
              {/*            value={attr.key}*/}
              {/*            className="w-1/3 p-2 border rounded-lg"*/}
              {/*            readOnly*/}
              {/*        />*/}
              {/*        <input*/}
              {/*            type="text"*/}
              {/*            value={attr.value}*/}
              {/*            className="w-1/3 p-2 border rounded-lg"*/}
              {/*            readOnly*/}
              {/*        />*/}
              {/*        <button*/}
              {/*            type="button"*/}
              {/*            onClick={() => removeAttribute(index)}*/}
              {/*            className="text-red-500 hover:text-red-700"*/}
              {/*        >*/}
              {/*            <X size={18} />*/}
              {/*        </button>*/}
              {/*    </div>*/}
              {/*))}*/}
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="color"
                  className="w-1/3 p-2 border rounded-lg"
                  value={formData.attributes.color}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      attributes: {
                        ...formData.attributes,
                        color: e.target.value,
                      },
                    })
                  }
                />
                <input
                  type="text"
                  placeholder="Size"
                  className="w-1/3 p-2 border rounded-lg"
                  value={formData.attributes.size}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      attributes: {
                        ...formData.attributes,
                        size: e.target.value,
                      },
                    })
                  }
                />
                {/*<button*/}
                {/*    type="button"*/}
                {/*    // onClick={addAttribute}*/}
                {/*    className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"*/}
                {/*>*/}
                {/*    Add*/}
                {/*</button>*/}
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t flex justify-end gap-4">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-2 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center gap-2"
              onClick={createProduct}
            >
              {isLoading ? (
                <span className="animate-pulse">Creating...</span>
              ) : (
                <>
                  <Plus size={18} />
                  Create Product
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
